import CRUD from './crud'
import axios from '../../utils/axios';

const tournamentParticipants = new CRUD('tournament-participants')

export default Object.assign(
    tournamentParticipants,
    {
        reducers: {
            ...tournamentParticipants.reducers
        },

        decline: (data) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios
                        .post(`/tournament-participants/decline`, data)
                        .catch(error => {
                            console.log('AXIOS error', error)
                        })
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
